/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo, useLayoutEffect, useState } from "react";

import ReactLoading from 'react-loading';

// 入力フォームのstore保存
import { useStateMachine } from "little-state-machine";
import { getStore } from "stores/actions.js";

// CSS読み込み
import { mtgGroup, mtgBody, mtgBodyNoMb } from "assets/css/stylesCss";
import { uktkNm, bunner, loadingCss } from "assets/css/shchMtmr";
import CardUktk from "components/ui/card/CardUktk";
import { isEmpty } from "utilities/string";

// バナーアイコン
const mtgBunner = require("assets/img/bunner/mtg_banner_pc.png");

/**
 * ご希望日時の選択
 */
const Thanks = memo(() => {

  const [isLoading, setIsLoading] = useState(true);

  // store取得・更新
  const { state } = useStateMachine(getStore);

  // MTGバナー表示分岐
  let isMtgBunner = false;
  if (isEmpty(state.storeContract.mtgLoginSelect)) isMtgBunner = true;

  // バナー画像の読み込みを待機
  useLayoutEffect(() => {

    // バナー画像が必要な場合のみ取得
    if (isMtgBunner) {
      const img = new Image();
      img.src = mtgBunner;

      img.onload = () => {
        setIsLoading(false);
      };
    } else {
      setIsLoading(false)
    }

  }, []);

  return (
    <>
      {isLoading ? (
        <div css={[loadingCss]}>
          <ReactLoading type="spin" color="#b5b5b5" height="50px" width="50px" />
        </div>
      ) : (
        <>
          <h1>申込完了</h1>

          {/** 完了メッセージ */}
          <div css={mtgGroup}>
            <p css={mtgBody}>
              お申し込みありがとうございました。ご入力いただいたメールアドレスに、予約確認メールを送信しました。予約確認メールには、お問合せ先が記載されています。
            </p>
          </div>

          {/** 受付番号確認 */}
          <div css={mtgGroup}>
            <CardUktk>
              <label css={uktkNm}>受付番号 <span>{state.storeConfirm.uktkNo}</span></label>
              <p css={mtgBodyNoMb}>受付番号は予約確認メールにも記載しています。</p>
            </CardUktk>
          </div>

          {/** バナー */}
          {isMtgBunner && (
            <div css={[mtgGroup, bunner]}>
              <a href="https://members.tokyo-gas.co.jp/?utm_source=mtg&utm_medium=banner&utm_campaign=mtg&utm_term=kiki_mitsumori">
                <img
                  src={mtgBunner}
                  alt="ガス料金等クレジットカード払い申し込み受付｜東京ガス株式会社"
                />
              </a>
            </div>
          )}
        </>
      )}
    </>
  );
});

export default Thanks;
